import { EmptyDataPlaceholderStyle } from './styles';

type EmptyDataPlaceholderProps = {
  text: string | React.ReactNode;
};
export function EmptyDataPlaceholder(props: EmptyDataPlaceholderProps) {
  const { text } = props;
  return <EmptyDataPlaceholderStyle>{text}</EmptyDataPlaceholderStyle>;
}
